import { ControlType, FormFieldBase } from './form-field-base.model';

export class TextFormField extends FormFieldBase<string | number> {
  controlType: ControlType = 'textfield';
}
